import TwoFactorPopupViewModel from '@/Components/TwoFaktorAuth/PopupWindow/TwoFactorPopupViewModel';
import ComponentManager from '@/Management/ComponentManager';
import Utilities from '@/Utility/Utilities';
import Window from '@/Controls/Window';
import QRCodeHelper from '@/Components/TwoFaktorAuth/QRCodeHelper';
import layout from './TwoFactorPopup.html?raw';
/**
 * Window-Komponente, welche den 2FA in einem Fenster anzeigt
 */
export default class TwoFactorPopup extends Window {
    /**
     * @override
     */
    public viewModel: TwoFactorPopupViewModel;

    protected $element: JQuery;

    public constructor(viewModel: TwoFactorPopupViewModel, element?: JQuery) {
        let $element = element || $('<div>');
        super(viewModel, $element);

        this.applyTemplate(layout, $element, () => {
            this.$element = $element;
            this.onAfterRender();
        });

        this.defineSubscription(this.viewModel.twoFactorViewModel.token, (token) => {
            const $qrCode = this.$element.find('.qr-code');
            if (!Utilities.isNullOrUndefinedOrBlank(token))
                QRCodeHelper.createQRCodeOnElement($qrCode, token);
            else
                QRCodeHelper.cleanUpArea($qrCode)
        })
    }
    
    protected onAfterRender(): void {
        this.viewModel.isOpen(true);
    }

    public getElementToAppended(): JQuery<HTMLElement> {
        return $('[data-region=Modal]');
    }
}

ComponentManager.setControl('TwoFactorPopup', TwoFactorPopup, 'RADPresentation.HTMLClient.DefaultViewExtensions');